import {SelectOptionType} from "../../types/admin/selectOptionType";

// eslint-disable-next-line no-shadow
export enum MenuType {
  MATERIAL = 1,
  SUB_MENU = 2,
  TASK_BOARD = 3,
  VH_CHAT = 4,
  MEMBER_CHAT = 5,
  VIDEO_CONFERENE = 6,
  GUEST_INVITATION = 7,
  VH_PRESENTATION = 8,
}

export const getMenuTypeText = (menuType: MenuType): string => {
   let text: string = '';

  switch (menuType) {
    case MenuType.MATERIAL:
      text = '資料';
      break;
    case MenuType.SUB_MENU:
      text = 'サブメニュー表示';
      break;
    case MenuType.TASK_BOARD:
      text = 'タスクボード';
      break;
    case MenuType.VH_CHAT:
      text = 'VHチャット';
      break;
    case MenuType.MEMBER_CHAT:
      text = 'メンバーチャット';
      break;
    case MenuType.VIDEO_CONFERENE:
      text = 'ビデオ会議';
      break;
    case MenuType.GUEST_INVITATION:
      text = 'ゲスト招待';
      break;
    case MenuType.VH_PRESENTATION:
      text = '自動プレゼン';
      break;
    default:
      // ToDo: Errorクラス、エラーメッセージをもっと適当なものに
      throw new Error(`想定していないMenuType（${menuType}）が渡されました。`);
  }

  return text;
};

export const getMenuTypeSelectOptions = (): SelectOptionType[] => {
  return (Object.keys(MenuType) as Array<keyof typeof MenuType>)
    .map(key => parseInt(key, 10))
    .filter( key => !Number.isNaN(key))
    .map((key: number) => {
      const selectOption: SelectOptionType = {
        value: key,
        label: getMenuTypeText(key),
      }
      return selectOption;
    });
}